/**
 * Directive: relatedProgramTemplates
 */
angular.module('acme.common.directive.relatedProgramTemplates', [
  'acme.common.service.api'
])
.directive('relatedProgramTemplates', [ 'ApiService', 'HelpersService', function(ApiService, HelpersService) {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/relatedProgramTemplates/relatedProgramTemplates.tpl.html',
      scope: {
        resourceTemplateId: '@resourcetemplateid'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.relatedProgramTemplates = {

          showErrors: false,

          isLoaded: false,
          isLoading: false,

          model: {
          },

          hasTemplates: function() {
            return (this.model.templates && this.model.templates.length > 0);
          },

          getTemplates: function() {

            this.model.templates = [];
            this.isLoading = true;
            this.isLoaded = false;
console.log($scope.resourceTemplateId);
            ApiService.resource.programs.list($scope.resourceTemplateId).then(this.success, this.error);
          },

          success: function(response, status, headers, config) {
            $scope.relatedProgramTemplates.isLoading = false;
            $scope.relatedProgramTemplates.isLoaded = true;
            $scope.relatedProgramTemplates.showErrors = false;
            $scope.relatedProgramTemplates.model.templates = response.data.program_summaries;
          },

          error: function(response, status, headers, config) {
            $scope.relatedProgramTemplates.isLoading = false;
            $scope.relatedProgramTemplates.isLoaded = true;
            $scope.relatedProgramTemplates.showErrors = true;

          }

        };

      }]

    };

}]);